import socketIO from 'socket.io-client'
import { useEffect, useState, useMemo } from 'react'
import { getAuthToken } from '../helper/storage'

export const useCustomSocket = (chatRoomId) => {
  const [socketConnection, setSocketConnection] = useState(false)
  const [messages, setMessages] = useState([])
  const [typingUser, setTypingUser] = useState(null)
  const [isUserOnline, setIsUserOnline] = useState(null)
  const socket = useMemo(() => {
    return chatRoomId
      ? socketIO(`${process.env.REACT_APP_SOCKET_URL}/chat?chatRoomId=${chatRoomId}`, {
          extraHeaders: {
            Authorization: getAuthToken()
          }
        })
      : ''
  }, [chatRoomId])

  useEffect(() => {
    if (typingUser) {
      setTimeout(() => {
        setTypingUser(null)
      }, 10000)
    }
  }, [typingUser])

  const socketSendMessage = (inputValue) => {
    socket.emit('send_message', {
      chatRoomId,
      message: inputValue
    })
  }

  const socketTyping = (userName) => {
    socket.emit('typing', { name: userName })
  }

  const socketIsTyping = (name) => {
    console.log('> User Typing', name)
    setTypingUser(name)
  }

  const handleDisconnect = () => {
    console.log('> Disconnected to server')
    socket.disconnect()
    socket.on('disconnect', () => {
      console.log('> Disconnected to server')
      setSocketConnection(false)
    })
  }
  useEffect(() => {
    return () => handleDisconnect()
  }, [])
  useEffect(() => {
    if (location?.pathname?.split('/')?.includes('chat') && !socketConnection) {
      const handleConnect = () => {
        console.log('> Connected to server')
        setSocketConnection(true)
      }
      if (socket) {
        socket.on('connect', handleConnect)
      }
    }
  }, [location, socketConnection])

  useEffect(() => {
    const handleIsOnline = () => {
      console.log('> User Online')
      socket.emit('join_room')
      socket.emit('chat_list', { chatRoomId })
    }

    const handleMessages = (response) => {
      console.log('> Messages received')
      setMessages(response)
    }

    const handleAnotherUserOnline = (data) => {
      console.log('> Another user online')
      setIsUserOnline(data?.is_online || false)
    }

    const handleReloadChatList = () => {
      console.log('> Reload Chat called')
      socket.emit('chat_list', { chatRoomId })
    }
    if (socket) {
      socket.on('is_online', handleIsOnline)
      socket.on('messages', handleMessages)
      socket.on('another_user_online', handleAnotherUserOnline)
      socket.on('reload_chat_list', handleReloadChatList)
      socket.on('is_user_typing', socketIsTyping)
    }
    return () => {
      socket.off('is_online', handleIsOnline)
      socket.off('messages', handleMessages)
      socket.off('another_user_online', handleAnotherUserOnline)
      socket.off('reload_chat_list', handleReloadChatList)
      socket.off('is_user_typing', socketIsTyping)
    }
  }, [socketConnection])

  return {
    messages,
    typingUser,
    isUserOnline,
    socketSendMessage,
    socketTyping,
    handleDisconnect
  }
}
